/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowTableRowsListRequest {
    getFixupPrototypeFunction() { return ServiceNowTableRowsListRequest.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowTableRowsListRequest>): ServiceNowTableRowsListRequest {
        let obj = Object.assign(new ServiceNowTableRowsListRequest(), model);
        ServiceNowTableRowsListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowTableRowsListRequest>): ServiceNowTableRowsListRequest {
        if (!model) return null;
        return ServiceNowTableRowsListRequest.newInstance(<ServiceNowTableRowsListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowTableRowsListRequest) {
        if (!obj) return;

        models.ServiceNowTableRowsListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowTableRowsListRequest): boolean {
        Object.setPrototypeOf(obj, ServiceNowTableRowsListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

}
